import { cloneElement, ReactElement, ReactNode } from 'react';

import {
  ApiOutlined,
  CreditCardOutlined,
  DesktopOutlined,
  MobileOutlined,
  ShopOutlined,
  SwapOutlined,
  ThunderboltFilled,
} from '@ant-design/icons';
import { Tag } from 'antd';

import { COLORS } from '../../../utils/theme/colors';

export type Origin =
  | 'AUTOCHARGE'
  | 'APP_EDENRED'
  | 'APP_USEBARATAO'
  | 'TERMINAL_MACHINE_CONDUPAY'
  | 'TERMINAL'
  | 'OCPI'
  | 'CROSS';

interface OriginConfig {
  label: string;
  color: string;
  icon: ReactNode;
}

const ORIGIN_CONFIG: Record<Origin, OriginConfig> = {
  AUTOCHARGE:                { label: 'Auto Charge', color: COLORS.popular,   icon: <ThunderboltFilled /> },
  APP_EDENRED:               { label: 'Edenred',     color: '#E30613',        icon: <MobileOutlined /> },
  APP_USEBARATAO:            { label: 'Baratão',     color: '#EB2F96',        icon: <ShopOutlined /> },
  TERMINAL_MACHINE_CONDUPAY: { label: 'Maquininha',  color: '#722ED1',        icon: <CreditCardOutlined /> },
  TERMINAL:                  { label: 'Terminal',    color: COLORS.recharges, icon: <DesktopOutlined /> },
  OCPI:                      { label: 'OCPI',        color: '#FA8C16',        icon: <ApiOutlined /> },
  CROSS:                     { label: 'Cross',       color: '#595959',        icon: <SwapOutlined /> },
};

export const getOriginBadgeConfig = (
  origin: string | undefined | null,
): OriginConfig | null => {
  if (!origin) return null;
  return ORIGIN_CONFIG[origin as Origin] ?? null;
};

interface OriginBadgeProps {
  origin?: string;
}

export const OriginBadge = ({ origin }: OriginBadgeProps) => {
  const config = getOriginBadgeConfig(origin);
  if (!config) return null;

  const { label, color, icon } = config;
  return (
    <Tag
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 3,
        marginLeft: 6,
        marginRight: 0,
        color,
        background: `${color}14`,
        border: `1px solid ${color}`,
        borderRadius: 10,
        fontSize: 11,
        lineHeight: '14px',
        padding: '2px 7px',
      }}
    >
      {cloneElement(icon as ReactElement, { style: { color } })}
      {label}
    </Tag>
  );
};
